import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { orderPoStyles } from "@insite/content-library/Widgets/OrderDetails/OrderPo";
import { TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

orderPoStyles.titleText = mergeToNew(orderPoStyles.titleText, {
    css: css`
       line-height: ${TYPOGRAPHY.lineHeight.xxmedium};
       font-weight: ${TYPOGRAPHY.weight.mediumbold};
       margin-bottom: 5px;
    `,
});


